import { render, staticRenderFns } from "./pin-form.vue?vue&type=template&id=048dcf40&"
import script from "./pin-form.js?vue&type=script&lang=js&"
export * from "./pin-form.js?vue&type=script&lang=js&"
import style0 from "./pin-form.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports